import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { footer_gray, green, pink, Salamstree } from '../../constants';
import chetna from '../../images/chetna.png'
import Typography from '@mui/material/Typography';
import { FaArrowRight } from 'react-icons/fa';
import { Button, Link } from 'react-scroll';
import { useNavigate } from 'react-router-dom';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}


export default function ScrollableTabsButtonAuto() {
    const [value, setValue] = React.useState(0);

    let navigate = useNavigate();



    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function handlenavigate(item, id) {
      
        navigate('/salaamstree/' + item.title + '/' + id, {replace: false,state:{item:item.items[id],category:item.title}} );
    }


    return (
        <Box sx={{ maxWidth: "100%", bgcolor: 'background.paper' }}>

            <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                textColor='inherit'
                aria-label="scrollable auto tabs example"

                TabIndicatorProps={{
                    style: { background: pink, }
                }}
            >
                {Salamstree.map((value, index) => {
                    return <Tab key={index} label={value.title} index={index} >
                    </Tab>
                }
                )}

            </Tabs>



            <TabPanel value={value} index={0} style={{ padding: "0px", }} >

                <div className='tab_bar_container'>
                    {
                        Salamstree[0].items.map((val, index) => {
                            return <div key={index}>
                                <button onClick={() => handlenavigate(Salamstree[0], index)} style={{ cursor: "pointer", border: "none", backgroundColor: "white" }}>
                                    <div className='scroll-item'>
                                        <div className='card-img'>
                                            <img src={val.url} style={{ borderRadius: "5px" }} width="100%" height="100%"></img>
                                        </div>

                                        <div className='card-content' style={{ alignItems: "start" }}>
                                            <span className='card-content-title'>{val.name}</span>

                                            <div style={{ display: "flex", flexDirection: "row", margin: "5px" }}>
                                                <span style={{ color: pink, fontSize: "60px", textAlign: "start", lineHeight: "40px", fontWeight: "bold", marginRight: "5px" }}>“</span>
                                                <span className='card-content-des' style={{maxLines:2}}>{val.des}</span>
                                            </div>

                                            
                                            
                                        </div>
                                        <div className='arrow'>
                                            <FaArrowRight size="25px" style={{ color: pink }}></FaArrowRight>
                                        </div>

                                       
                                    </div>
                                </button>

                            </div>

                        }

                        )
                    }
                </div>
            </TabPanel>

            <TabPanel value={value} index={1} style={{ padding: "0px", }} >

                <div className='tab_bar_container'>
                    {
                        Salamstree[1].items.map((val, index) => {
                            return <div key={index}>
                                <button onClick={() => handlenavigate(Salamstree[1], index)} style={{ cursor: "pointer", border: "none", backgroundColor: "white" }}>
                                    <div className='scroll-item'>
                                        <div className='card-img'>
                                            <img src={val.url} style={{ borderRadius: "5px" }} width="100%" height="100%"></img>
                                        </div>

                                        <div className='card-content' style={{ alignItems: "start" }}>
                                            <span className='card-content-title'>{val.name}</span>

                                            <div style={{ display: "flex", flexDirection: "row", margin: "5px" }}>
                                                <span style={{ color: pink, fontSize: "60px", textAlign: "start", lineHeight: "40px", fontWeight: "bold", marginRight: "5px" }}>“</span>
                                                <span className='card-content-des' style={{maxLines:2}}>{val.des}</span>
                                            </div>

                                            
                                            
                                        </div>
                                        <div className='arrow'>
                                            <FaArrowRight size="25px" style={{ color: pink }}></FaArrowRight>
                                        </div>

                                       
                                    </div>
                                </button>

                            </div>

                        }

                        )
                    }
                </div>
            </TabPanel>

            <TabPanel value={value} index={2} style={{ padding: "0px", }} >

                <div className='tab_bar_container'>
                    {
                        Salamstree[2].items.map((val, index) => {
                            return <div key={index}>
                                <button onClick={() => handlenavigate(Salamstree[2], index)} style={{ cursor: "pointer", border: "none", backgroundColor: "white" }}>
                                    <div className='scroll-item'>
                                        <div className='card-img'>
                                            <img src={val.url} style={{ borderRadius: "5px" }} width="100%" height="100%"></img>
                                        </div>

                                        <div className='card-content' style={{ alignItems: "start" }}>
                                            <span className='card-content-title'>{val.name}</span>

                                            <div style={{ display: "flex", flexDirection: "row", margin: "5px" }}>
                                                <span style={{ color: pink, fontSize: "60px", textAlign: "start", lineHeight: "40px", fontWeight: "bold", marginRight: "5px" }}>“</span>
                                                <span className='card-content-des' style={{maxLines:2}}>{val.des}</span>
                                            </div>

                                            
                                            
                                        </div>
                                        <div className='arrow'>
                                            <FaArrowRight size="25px" style={{ color: pink }}></FaArrowRight>
                                        </div>

                                       
                                    </div>
                                </button>

                            </div>

                        }

                        )
                    }
                </div>
            </TabPanel>

            <TabPanel value={value} index={3} style={{ padding: "0px", }} >

                <div className='tab_bar_container'>
                    {
                        Salamstree[3].items.map((val, index) => {
                            return <div key={index}>
                                <button onClick={() => handlenavigate(Salamstree[3], index)} style={{ cursor: "pointer", border: "none", backgroundColor: "white" }}>
                                    <div className='scroll-item'>
                                        <div className='card-img'>
                                            <img src={val.url} style={{ borderRadius: "5px" }} width="100%" height="100%"></img>
                                        </div>

                                        <div className='card-content' style={{ alignItems: "start" }}>
                                            <span className='card-content-title'>{val.name}</span>

                                            <div style={{ display: "flex", flexDirection: "row", margin: "5px" }}>
                                                <span style={{ color: pink, fontSize: "60px", textAlign: "start", lineHeight: "40px", fontWeight: "bold", marginRight: "5px" }}>“</span>
                                                <span className='card-content-des' style={{maxLines:2}}>{val.des}</span>
                                            </div>

                                            
                                            
                                        </div>
                                        <div className='arrow'>
                                            <FaArrowRight size="25px" style={{ color: pink }}></FaArrowRight>
                                        </div>

                                       
                                    </div>
                                </button>

                            </div>

                        }

                        )
                    }
                </div>
            </TabPanel>

            <TabPanel value={value} index={4} style={{ padding: "0px", }} >

                <div className='tab_bar_container'>
                    {
                        Salamstree[4].items.map((val, index) => {
                            return <div key={index}>
                                <button onClick={() => handlenavigate(Salamstree[4], index)} style={{ cursor: "pointer", border: "none", backgroundColor: "white" }}>
                                    <div className='scroll-item'>
                                        <div className='card-img'>
                                            <img src={val.url} style={{ borderRadius: "5px" }} width="100%" height="100%"></img>
                                        </div>

                                        <div className='card-content' style={{ alignItems: "start" }}>
                                            <span className='card-content-title'>{val.name}</span>

                                            <div style={{ display: "flex", flexDirection: "row", margin: "5px" }}>
                                                <span style={{ color: pink, fontSize: "60px", textAlign: "start", lineHeight: "40px", fontWeight: "bold", marginRight: "5px" }}>“</span>
                                                <span className='card-content-des' style={{maxLines:2}}>{val.des}</span>
                                            </div>

                                            
                                            
                                        </div>
                                        <div className='arrow'>
                                            <FaArrowRight size="25px" style={{ color: pink }}></FaArrowRight>
                                        </div>

                                       
                                    </div>
                                </button>

                            </div>

                        }

                        )
                    }
                </div>
            </TabPanel>

            {/* <TabPanel value={value} index={5} style={{ padding: "0px", }} >

                <div className='tab_bar_container'>
                    {
                        Salamstree[5].items.map((val, index) => {
                            return <div key={index}>
                                <button onClick={() => handlenavigate(Salamstree[5], index)} style={{ cursor: "pointer", border: "none", backgroundColor: "white" }}>
                                    <div className='scroll-item'>
                                        <div className='card-img'>
                                            <img src={val.url} style={{ borderRadius: "5px" }} width="100%" height="100%"></img>
                                        </div>

                                        <div className='card-content' style={{ alignItems: "start" }}>
                                            <span className='card-content-title'>{val.name}</span>

                                            <div style={{ display: "flex", flexDirection: "row", margin: "5px" }}>
                                                <span style={{ color: pink, fontSize: "60px", textAlign: "start", lineHeight: "40px", fontWeight: "bold", marginRight: "5px" }}>“</span>
                                                <span className='card-content-des' style={{maxLines:2}}>{val.des}</span>
                                            </div>

                                            
                                            
                                        </div>
                                        <div className='arrow'>
                                            <FaArrowRight size="25px" style={{ color: pink }}></FaArrowRight>
                                        </div>

                                       
                                    </div>
                                </button>

                            </div>

                        }

                        )
                    }
                </div>
            </TabPanel>

            <TabPanel value={value} index={6} style={{ padding: "0px", }} >

                <div className='tab_bar_container'>
                    {
                        Salamstree[6].items.map((val, index) => {
                            return <div key={index}>
                                <button onClick={() => handlenavigate(Salamstree[6], index)} style={{ cursor: "pointer", border: "none", backgroundColor: "white" }}>
                                    <div className='scroll-item'>
                                        <div className='card-img'>
                                            <img src={val.url} style={{ borderRadius: "5px" }} width="100%" height="100%"></img>
                                        </div>

                                        <div className='card-content' style={{ alignItems: "start" }}>
                                            <span className='card-content-title'>{val.name}</span>

                                            <div style={{ display: "flex", flexDirection: "row", margin: "5px" }}>
                                                <span style={{ color: pink, fontSize: "60px", textAlign: "start", lineHeight: "40px", fontWeight: "bold", marginRight: "5px" }}>“</span>
                                                <span className='card-content-des' style={{maxLines:2}}>{val.des}</span>
                                            </div>

                                            
                                            
                                        </div>
                                        <div className='arrow'>
                                            <FaArrowRight size="25px" style={{ color: pink }}></FaArrowRight>
                                        </div>

                                       
                                    </div>
                                </button>

                            </div>

                        }

                        )
                    }
                </div>
            </TabPanel> */}

            





        </Box>

    );
}
